if (document.querySelector('.des_accordion')) {
  var dds = document.getElementsByClassName("des_accordion");
  var acc = dds[0].getElementsByTagName("h3");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var tables = document.querySelectorAll("table:not(.class)");
  for (var i = 0; i < tables.length; i++) {
    if (tables[i]) {
      tables[i].classList.add("table", "table-bordered", "table-hover");
      var wrapper = document.createElement("div");
      wrapper.classList.add("table-responsive");
      if (tables[i].parentNode) {
        tables[i].parentNode.insertBefore(wrapper, tables[i]);
        wrapper.appendChild(tables[i]);
      }
    }
  }
});

document.addEventListener('contextmenu', function(e) {  
  e.preventDefault();  
});


document.addEventListener('DOMContentLoaded', function () {
  var cratingCount; // 在共享的作用域中声明 cratingCount 变量

  setTimeout(function () {
    var cratingcountElement = document.querySelector('.cratingcount');
    if (cratingcountElement) {
      var cratingCountText = cratingcountElement.textContent.trim();
      // 过滤掉非数字字符，只保留数字部分
      cratingCountText = cratingCountText.replace(/\D/g, ''); 
      cratingCount = parseInt(cratingCountText, 10); // 定义 cratingCount 变量
    } else {
      cratingCount = 30;
    }

    var prevBadgeElements = document.querySelectorAll('.jdgm-prev-badge__text');

    prevBadgeElements.forEach(function (element) {
      var textContent = element.textContent.trim();
      var match = textContent.match(/\b\d+\b/);

      if (match && match.length > 0) {
        var number = parseInt(match[0], 10);
        var newTextContent = cratingCount + number;

        // Apply visibility: visible !important; style
        element.style.visibility = 'visible';
        element.style.setProperty('visibility', 'visible', 'important'); // Add !important
        // Preserve the original text
        element.textContent = textContent.replace(match[0], newTextContent);
      }
    });

    var firstHistogramElement = document.querySelector('.jdgm-histogram__frequency');

    if (firstHistogramElement) {
      var textContent = firstHistogramElement.textContent.trim();
      var match = textContent.match(/\b\d+\b/);

      if (match && match.length > 0) {
        var number = parseInt(match[0], 10);
        var newTextContent = cratingCount + number;

        // Apply visibility: visible !important; style
        firstHistogramElement.style.visibility = 'visible';
        firstHistogramElement.style.setProperty('visibility', 'visible', 'important'); // Add !important
        // Preserve the original text
        firstHistogramElement.textContent = textContent.replace(match[0], newTextContent);
      }
    }

    var summaryElement = document.querySelector('.jdgm-rev-widg__summary-text');

    if (summaryElement) {
      var textContent = summaryElement.textContent.trim();
      var match = textContent.match(/\b\d+\b/);

      if (match && match.length > 0) {
        var number = parseInt(match[0], 10);
        
        if (!isNaN(number)) {
          var newTextContent = cratingCount + number;
          summaryElement.textContent = textContent.replace(match[0], newTextContent);
        } else {
          console.error('Invalid number extracted from .jdgm-rev-widg__summary-text:', number);
        }
      } else {
        console.error('No match found in .jdgm-rev-widg__summary-text');
      }
    }
  }, 3000); // 延迟 1 秒钟
});

function resizeVideo() {
    var videos = document.getElementsByClassName("youtube-video");
    for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        var containerWidth = video.offsetWidth;
        video.style.height = (containerWidth * 9 / 16) + "px"; // Assuming 16:9 aspect ratio
    }
}

window.addEventListener("resize", resizeVideo);

window.onload = function() {
    resizeVideo();
};
